import Select from "react-select";
import { useEffect, useState } from "react";
import axios from "axios";
import { env } from "../../../constants/env";
import { useAuth } from "../../../context/AuthContext";

function LabSelector({ selectedLabs, setSelectedLabs }) {
  const { token } = useAuth();
  const [labs, setLabs] = useState([]);

  useEffect(() => {
    const fetchLabs = async () => {
      const res = await axios.get(`${env.kataApiUrl}/api/labs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const options = res.data.map((lab) => ({
        label: `${lab.labName} (${lab.city})`,
        value: lab._id,
      }));
      setLabs(options);
    };
    fetchLabs();
  }, []);

  return (
    <div>
      <label>Select Labs:</label>
      <Select
        options={labs}
        isMulti
        value={labs.filter((lab) => selectedLabs.includes(lab.value))}
        onChange={(selected) => setSelectedLabs(selected.map((s) => s.value))}
      />
    </div>
  );
}

export default LabSelector;
